<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Account Settings</h1>
      <div class="div-page-description"><h5>Manage your account settings and subscription details here.</h5></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="card row-height">

            <div class="card-body">
              <h5 class="card-title">Your Subscription</h5>
              <app-spinner *ngIf="!currentPlan"></app-spinner>
              <h4 *ngIf="currentPlan">{{currentPlan}} Plan</h4>
              <p *ngIf="currentPlan">{{currentPlanText}}</p>
              <p *ngIf="currentPlan!='Starter'">You can cancel, upgrade or downgrade your plan by clicking 'Manage Subscription' button below.</p>
              <div *ngIf="currentPlan">
                <button *ngIf="currentPlan!='Starter'" class="btn btn-primary" (click)="manageSubscription()">Manage Subscription</button>
                <button *ngIf="currentPlan=='Starter'" class="btn btn-primary" [routerLink]="['/pricing']">Upgrade</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card row-height">
            <div class="card-body">
              <h5 class="card-title">Delete Account</h5>
              <p>You have the option to erase all personal data and deactivate your account entirely.</p>
              <p><b>Note that this action can not be reversed.</b></p>
              <button class="btn btn-danger mt-2" (click)="deleteAccount()">Delete Account</button>
            </div>
          </div>
        </div>
      </div>


    </div>
  </section>
</main>



<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
